export default __webpack_public_path__ + "static/media/confirmed-link-icon.a24e1bc5.svg";